import { useMutation } from "@tanstack/react-query";
import { post } from "api/api-methods";
import { useBookingId } from "hooks/use-booking-id";
import { useError } from "hooks/use-error";
import queryClient from "query-client";
import { BookingMenu } from "types/menu";
import { error as logError } from "logger/logger";

interface UseBookingMenuRespondOptions {
    showGlobalErrorModal?: boolean;
}

export const useBookingMenuRespond = ({
    showGlobalErrorModal = true,
}: UseBookingMenuRespondOptions = {}) => {
    const { setErrorCode, openReservationFailedModal } = useError();
    const id = useBookingId();

    const updateBookingMenu = async ({
        bookingMenu,
        isReRespond,
    }: {
        bookingMenu: BookingMenu;
        isReRespond?: boolean;
    }) => {
        try {
            const url = isReRespond
                ? "BookingMenu/BookingMenusExternal/Respond?isReRespond=true"
                : "BookingMenu/BookingMenusExternal/Respond";
            const menu = await post<BookingMenu[], BookingMenu[]>(url, [bookingMenu]);
            await queryClient.invalidateQueries({
                queryKey: ["booking", id],
            });
            return menu;
        } catch (error) {
            const response = (error as { response?: { data?: { code: number } } })?.response?.data;
            logError(error);
            const errorCode = response?.code;
            if (showGlobalErrorModal && typeof errorCode === "number") {
                setErrorCode(errorCode);
                openReservationFailedModal();
            }
            throw error;
        }
    };

    return useMutation({
        mutationFn: updateBookingMenu,
        scope: {
            id: "webbooking-create",
        },
    });
};
